export default __webpack_public_path__ + "static/media/facebookround.f16c603d.svg";